export function isAssemblyKeytermsEnabled(featureFlags?: Record<string, unknown>): boolean {
  return featureFlags?.ASSEMBLY_KEY_TERMS_ENABLED === true;
}
